export class BookingDetailContext {
    
    public routeTo: string[] = []
    public bookingId!: string
     constructor() { }
 }